import Link from 'next/link';
import BackArrow from '../../public/svg/back-arrow.svg';
import { Button } from './backButton.styles';

type colorType = 'white' | 'black';

type Props = {
  url: string;
  label: string;
  color?: colorType
};

const BackButton = ({ url, label, color }: Props) => (
  <Link href={url} legacyBehavior>
    <Button colorType={color}>
      <BackArrow />
      {label}
    </Button>
  </Link>
);

export default BackButton;
